
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import dayjs from 'dayjs'
import {
  getPiCombinedUnit,
  getSupplierProduct,
  putPiCombinedUnit,
} from "@/api/proforma";
import { payment } from "@/api/supplier-payment";
import { deepClone } from "@/utils/deepClone";

@Component({
  name: "creditOrEditNote",
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: false }) private isAnnual: boolean;
  @Prop({ default: "付款" }) private title: "";
  @Prop({ default: {} }) private selectedItem: {};

  @Watch("show", { immediate: true })
  private async watchData() {
    if ((this.selectedItem as any).id && this.show) {
      this.table.list = [this.selectedItem];
      var now = dayjs().format('YYYY-MM-DD HH:mm:ss');
      this.$set(this.table.list[0], "time",now);
    }
  }

  private form = {} as any;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  public tableCol = [
    {
      label: "付款单号",
      prop: "code",
      key: "code",
      show: true,
      disabled: false,
    },
    {
      label: "付款供应商",
      prop: "supplier",
      key: "supplier",
      show: true,
      disabled: false,
    },
    {
      label: "付款金额",
      prop: "paymentAmount",
      key: "paymentAmount",
      show: true,
      disabled: false,
    },
    {
      label: "索赔金额",
      prop: "claimsAmount",
      key: "claimsAmount",
      show: true,
      disabled: false,
    },
    {
      label: "付款日期",
      prop: "time",
      key: "time",
      type: "datetime",
      // format: 'yyyy-MM-dd HH:mm:ss',
      show: true,
      disabled: false,
      width: "200",
    },
  ];

  private close() {
    this.$emit("update:show", false);
  }

  private open() {
    this.$emit("update:show", true);
  }

  private async submitForm(): Promise<void> {
    this.$confirm("是否确认付款？一旦确认后将无法撤销", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      this.payment();
    });
  }

  private onSelectionChange(rows: any[]) {
    console.log(rows);
  }

  public async handleDelete(scope) {
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
  }

  // 付款
  private async payment() {
    const { time, id } = this.table.list[0];
    try {
      let params = {
        paymentTime: dayjs(time).format("YYYY-MM-DD HH:mm:ss"),
      };
      await payment(id, params);
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      this.close();
      this.$emit("success", false);
    } catch {}
  }

  private async getPiCombinedUnit() {
    const res: any = await getPiCombinedUnit(this.form.id);
    this.getSupplierProduct(res.supplierId);
  }

  private async getSupplierProduct(supplierId) {
    const res: any = await getSupplierProduct(supplierId, {
      hqProductName: this.form.hqProductName,
    });
    this.$set(this.form, "shipmentChineseUnit", res.chineseUnit || "");
    this.$set(this.form, "shipmentEnglishUnit", res.englishUnit || "");
    this.$set(this.form, "shipmentQuantity", 1);
    this.$set(this.form, "deliveryQuantity", 1);
  }
}
